import { ReactNode } from "react"

interface Props {
    children: ReactNode
    idPortalName: string
}

export function CreatePortalAfterComponent({ children, idPortalName }: Props) {
    return (
        <>
            {children}
            <div id={idPortalName} />
        </>
    )
}
